const _temp0 = require("url:../../portfolio/assets/steve.webp");
module.exports = {
  "steve": _temp0
}